import boletaApi from "./boletaApi";

export const invoiceCsvExport = async (invoiceID) => {
  return boletaApi.get("/csvExportData", {
    params: { invoceId: invoiceID },
    responseType: "blob",
  });
};

export async function downloadInvoiceCsv(invoiceId) {
  const res = await invoiceCsvExport(invoiceId);
  const blob = new Blob([res.data], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "data.csv";
  a.click();
  URL.revokeObjectURL(url);
}
